export default __webpack_public_path__ + "static/media/contato.112ce099.png";